// extracted by mini-css-extract-plugin
export default {"svg":"SvgCanvas_svg__CE0CQ"};